import {
  ITennisMatchCard,
  TennisMatchCard,
} from "@sky-it-livedata/livedata-sports-design-system";

import { log } from "../../utils/log";
import { transformQuery } from "./transformers/query";
import { useSubscription } from "../../hooks/useSubscription";
import { MatchCardData, MatchCardSubscriptionData } from "./types";
import { transformSubscription } from "./transformers/subscription";
import { graphql } from "cdk/graphql";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<MatchCardData>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql("subscription onUpdateMatchCardById($matchId: ID!) {\n  onUpdateMatchCardById(matchId: $matchId) {\n    status\n    startDate\n    resultType\n    firstPosition {\n      isServing\n      score {\n        set\n        tie\n        isWinner\n      }\n      gamePoints\n      isWinner\n    }\n    secondPosition {\n      isServing\n      score {\n        set\n        tie\n        isWinner\n      }\n      gamePoints\n      isWinner\n    }\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<MatchCardData>): ITennisMatchCard {
  return transformQuery(props);
}

export default function Results({
  props,
  variables,
  ...rest
}: WidgetContext<ITennisMatchCard>) {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    ITennisMatchCard,
    MatchCardSubscriptionData,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables: {
      matchId: variables.matchId,
    },
    transform: transformSubscription,
    mergeData: true,
  }) as ITennisMatchCard;
  
  return <TennisMatchCard {...updatedProps}/>;
}
